(() => {
  'use strict';

  if (window.__twScrollPolicyV1) return;
  window.__twScrollPolicyV1 = true;

  /*
    Final-launch contract:
    Browser history restoration, hash navigation, focus scrolling and scripted
    scrolling remain native. Page-specific runtimes may still control their own
    interactions, but this global layer must not erase anchors, force scroll
    position, or monkey-patch browser scrolling APIs.
  */
  try {
    history.scrollRestoration = 'auto';
  } catch (_) {}
})();
